import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ConfirmDialog from "components/confirm-dialog";
import useToggle from "hooks/useToggle";
import { logOut } from "actions/account/auth";
import { ReactComponent as LogoutIcon  } from "assets/svgs/exit.svg";
import { useGlobalContext } from "context/global";

const LogOutUser = ({ icon, className = "", textColor = "", text }) => {
	const { translation } = useGlobalContext();
	const { authenticated } = useSelector((state) => state.account.profile);
	const [isOpen, toggle] = useToggle();

	const dispatch = useDispatch(); 

	if (!authenticated) return null;

	return (
		<>
			<ConfirmDialog
				isOpen={isOpen}
				confirmText="Log out"
				setIsOpen={toggle}
				callback={() => dispatch(logOut())}
				className="max-w-[350px]"
			/>
			<span className={`flex ${className}`}>
				<button style={{ color: textColor }} className="gap-3 w-fit flex items-center" onClick={toggle}>
					{icon && <LogoutIcon />}
					{text || translation.user?.log_out}	
				</button>
			</span>
		</>

	);
};

export default LogOutUser;
